import { useState } from "react";
import { TextPad } from "../shared";
import type { Booking } from "../../hooks/bookingTypes";
import { blockReasonOf, fmtOrenAt } from "./blockInfo";
import css from "./BlockForm.module.css";

/**
 * Тело модалки на заблокированном слоте. 28.09 (ДК: «чтобы было видно, зачем заблокировали
 * время»): причина — тап открывает TextPad (M.6 multiline, как при блокировке), поправленную
 * пишет штатное «Сохранить» (у блока оно шлёт только причину); ниже — кто и когда заблокировал
 * и кто менял. Причина живёт в comment-стейте модалки («БЛОК · …»), своего стейта у формы нет.
 */
export function BlockForm({ booking, comment, onComment }: { booking: Booking; comment: string; onComment: (v: string) => void }) {
  const [pad, setPad] = useState(false);
  const reason = comment.replace(/^БЛОК · /, "").trim() || blockReasonOf(booking);
  /* Блок поверх снятого до 28.09 оставлял в строке автора и время ПЕРВОГО блока — тогда
     блокировал тот, кто в blocked_by (сервер), в момент последней правки. */
  const revived = !!booking.blockedBy && booking.blockedBy !== booking.createdBy && /[а-яё]/i.test(booking.blockedBy);
  const who = revived ? booking.blockedBy : booking.createdBy;
  const at = revived ? booking.modifiedAt : booking.createdAt;
  const when = fmtOrenAt(at);
  const changed = booking.modifiedAt && booking.modifiedAt !== at ? fmtOrenAt(booking.modifiedAt) : "";
  return (
    <div className={css.box}>
      <div className={css.icon}>⛔</div>
      <p className={css.title}>Слот заблокирован</p>
      <button type="button" className={css.reason} data-pad-host="" onClick={() => setPad(true)}
        aria-label={`Причина блокировки: ${reason || "не указана"}. Тап — поправить`}>
        <span className={css.reasonLbl}>Причина</span>
        <span className={reason ? css.reasonTxt : css.reasonNone}>{reason || "не указана — тап, чтобы добавить"}</span>
      </button>
      {who || when ? <p className={css.meta}>Заблокировал(а): <b>{who || "—"}</b>{when ? ` · ${when}` : ""}</p> : null}
      {changed ? <p className={css.meta}>Изменено: <b>{booking.modifiedBy || "—"}</b> · {changed}</p> : null}
      <p className={css.hint}>Причину можно поправить — тап по ней, затем «Сохранить». Снять блок — «Разблокировать».</p>
      <TextPad
        open={pad}
        label="Причина блокировки"
        multiline
        maxLength={80}
        placeholder="Ремонт, класс, корпоратив…"
        value={reason}
        onCommit={(v) => { const t = v.trim(); if (t) onComment(`БЛОК · ${t}`); }}
        onClose={() => setPad(false)}
      />
    </div>
  );
}
